import { Context } from "@nuxt/types";
import axios from "axios";

import Api from "@/utils/api";

export const privacyServiceBaseUrl = "/v2/data_requests";

type RequestType = "access" | "erasure";
export interface PrivacyServiceResponse<T extends RequestType> {
  dataRequest: {
    requestType: T;
  };
}
type SubjectAccessRequestData = PrivacyServiceResponse<"access">;
type SubjectErasureRequestData = PrivacyServiceResponse<"erasure">;

const subjectAccessRequestPayload: Readonly<SubjectAccessRequestData> = {
  dataRequest: { requestType: "access" },
} as const;
const subjectErasureRequestPayload: Readonly<SubjectErasureRequestData> = {
  dataRequest: { requestType: "erasure" },
} as const;

export default class PrivacyService extends Api {
  url = privacyServiceBaseUrl;

  constructor($axios: Context["$axios"]) {
    super("privacyService", $axios);
  }

  async subjectAccess() {
    try {
      return await this.request<PrivacyServiceResponse<"access">>({
        method: "post",
        data: subjectAccessRequestPayload,
      });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.user_message);
      }
      throw error;
    }
  }

  async deleteAccount() {
    try {
      return await this.request<PrivacyServiceResponse<"erasure">>({
        method: "post",
        data: subjectErasureRequestPayload,
      });
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(error.response?.data?.user_message);
      }
      throw error;
    }
  }
}
